import defaultWebDropdown from '#themes/default/web/components/dropdown/dropdown.js';

import cCvcHint from '#themes/avast/web/components/cvcHint/cvcHint.js';
import cDropdownItem from '#themes/avast/web/components/dropdownItem/dropdownItem.js';
import cFormLine from '#themes/avast/web/components/formLine/formLine.js';
import cSkeleton from '#themes/avast/web/components/skeleton/skeleton.js';
import cSvg from '#themes/avast/web/components/svg/svg.js';

export default {
	components: {
		cCvcHint,
		cDropdownItem,
		cFormLine,
		cSkeleton,
		cSvg
	},
	extends: defaultWebDropdown
};
